"use client";

import { AlertTriangle } from "lucide-react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-12 min-h-[400px]">
      <AlertTriangle size={48} className="text-ikroot-danger" />
      <h2 className="text-lg font-bold text-ikroot-text">Something went wrong</h2>
      <p className="text-sm text-ikroot-text-dim max-w-md text-center">
        {error.message || "An unexpected error occurred."}
      </p>
      <button
        onClick={reset}
        className="px-4 py-2 text-sm bg-ikroot-accent text-white rounded-md hover:bg-ikroot-accent/90 transition-colors"
      >
        Try again
      </button>
    </div>
  );
}
